import { Info } from 'lucide-react';
import { cn } from '@/utils/cn';

type RecommendationReasonTooltipProps = {
  reason: string;
  className?: string;
};

export function RecommendationReasonTooltip({ reason, className }: RecommendationReasonTooltipProps) {
  if (!reason) return null;

  return (
    <span className={cn('inline-flex', className)}>
      <button
        type="button"
        className="inline-flex h-7 w-7 items-center justify-center rounded text-chrome-label hover:text-foreground-muted hover:bg-surface-muted"
        title={reason}
        aria-label={`Why recommended: ${reason}`}
      >
        <Info className="h-3.5 w-3.5" aria-hidden />
      </button>
    </span>
  );
}
